import createContext from '../../utils/createContext';

type PricePreviewContextValue = {
  shipping: number | null;
  total: number | null;
  onUpdatePreview?: ({
    shipping,
    total,
  }: {
    shipping: number | null;
    total: number | null;
  }) => void;
};

const [usePricePreviewContext, PricePreviewContext] =
  createContext<PricePreviewContextValue>('PricePreviewContext', {
    initialValue: { shipping: null, total: null },
  });

export { usePricePreviewContext };
export default PricePreviewContext;
